function TagBuilder(type) {
  this._type = type;
  this._attributes = new Array();
  this._content = "";
}
TagBuilder.prototype.addAttribute = function(
  name,
  value,
  addOnlyIfValueExists
) {
  var add = true;
  if (addOnlyIfValueExists && !value) {
    add = false;
  }
  if (add) {
    this._attributes.push(name + "=" + "'" + value + "'");
  }
  return this;
};
/**
 * Sets the content of the tag to the given text
 * @param text the text to put in the tag content.
 * @return the TagBuilder, for chained calls.
 */
TagBuilder.prototype.setText = function(text) {
  this._content = text.replace(/&/g, "&amp;").replace(/</g, "&lt;");
  return this;
};
TagBuilder.prototype.setContent = function(content) {
  this._content = content;
  return this;
};
TagBuilder.prototype.toString = function() {
  var closing = " />";
  if (this._content) {
    closing = " >" + this._content + "</" + this._type + ">";
  }
  return "<" + this._type + " " + this._attributes.join(" ") + closing;
};
